import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

const boostPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  impression_quantity: PropTypes.number,
  cost: PropTypes.number
});

const propTypes = {
  options: PropTypes.arrayOf(boostPropType).isRequired,
  selectedBoost: boostPropType,
  onSelect: PropTypes.func.isRequired
};

const ImpressionBoostDropdown = ({ options, selectedBoost = null, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} className="w-100">
      <DropdownToggle
        outline
        color="secondary"
        size="md"
        className="btn-sharp w-100 text-left d-flex justify-content-between align-items-center overflow-hidden"
      >
        <span className="text-truncate">
          {selectedBoost?.impression_quantity.toLocaleString()} more views - $
          {Math.round(selectedBoost?.cost / 100)}
        </span>
        <i className={`fa fa-chevron-${isOpen ? "up" : "down"} ml-2`} />
      </DropdownToggle>
      <DropdownMenu className="w-100">
        {options.map(boost => (
          <DropdownItem
            key={boost.id}
            onClick={() => onSelect(boost)}
            data-testid={`boost-option-${boost.impression_quantity}`}
          >
            {boost.impression_quantity.toLocaleString()} more views - $
            {Math.round(boost.cost / 100)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

ImpressionBoostDropdown.propTypes = propTypes;

export default ImpressionBoostDropdown;
